export default __webpack_public_path__ + "static/media/discount_bg.aeb97f5b.svg";